import styled from "styled-components/native";
import { TouchableHighlight, Text, View } from "react-native";
import { StrechedProps, StyledProps, DisabledProps } from "./types";
import { Theme } from "../../../../theming/types";

export const StyledPressable = styled(TouchableHighlight)<
  StyledProps & StrechedProps & DisabledProps
>`
  height: 48px;
  background-color: ${({ theme }: StyledProps) => theme.colors.white[900]};
  border-bottom-color: ${({ theme }: StyledProps) => theme.colors.blue[100]};
  border-bottom-width: ${({ noBorder }: StyledProps) =>
    noBorder ? "0" : "1px"};
  padding-left: ${({ theme }: StyledProps) => theme.space["space-4"]};
  padding-right: ${({ theme }: StyledProps) => theme.space["space-4"]};
  justify-content: center;
  align-items: center;
  ${({ isStretched }: StrechedProps) =>
    isStretched &&
    `
    flex-grow: 1;
  `}

  ${({
    isHovered,
    isDisabled,
    theme,
    hoverColor
  }: StyledProps & DisabledProps) =>
    isHovered &&
    `background-color: ${hoverColor || theme.colors.blue_accent["000"]};
    cursor: ${isDisabled ? "default" : "pointer"}
  `}
  
  ${({ isPressed, theme, hasPressedColor }: StyledProps) =>
    isPressed &&
    hasPressedColor &&
    `
    background-color: ${theme.colors.blue_accent[100]};
  `}
  
  ${({ isDisabled, theme }: StyledProps & DisabledProps) =>
    isDisabled &&
    `
    background-color: ${theme.colors.white[500]};
  `};
`;

export const StyledTextTitle = styled(Text)<StyledProps & DisabledProps>`
  color: ${({ theme, textTitleColor }: StyledProps) =>
    textTitleColor || theme.colors.grey[900]};
  font-size: ${({ theme }: StyledProps) => theme.fontSizes.s};
  font-family: ${({ theme }: StyledProps) => theme.fonts.medium};
  ${({ isSelected, theme, textTitleSelectedColor }: StyledProps) =>
    isSelected &&
    `
    color: ${textTitleSelectedColor || theme.colors.blue_accent[500]}
  `}

  ${({ isPressed, theme, hasPressedColor }: StyledProps) =>
    isPressed &&
    hasPressedColor &&
    `
    color: ${theme.colors.blue_accent[500]}
  `}

  ${({ isDisabled, theme }: StyledProps & DisabledProps) =>
    isDisabled &&
    `
    color: ${theme.colors.grey[600]};
  `}

  ${({ isTitleUppercase }: StyledProps) =>
    isTitleUppercase && `text-transform: uppercase;`}
`;

export const StyledViewIconContainer = styled(View)`
  margin-left: ${({ theme }: { theme: Theme }) => theme.space["space-1"]};
`;

export const StyledTextDescription = styled(Text)<StyledProps & DisabledProps>`
  font-size: ${({ theme }: { theme: Theme }) => theme.fontSizes.xs};
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.regular};
  color: ${({ theme }: { theme: Theme }) => theme.colors.grey[800]};
  margin-top: 2px;
  ${({ isSelected, theme }: StyledProps) =>
    isSelected &&
    `
    color: ${theme.colors.blue_accent[400]}
  `}

  ${({ isPressed, theme }: StyledProps) =>
    isPressed &&
    `
    color: ${theme.colors.blue_accent[400]}
  `}
  
  ${({ isDisabled, theme }: StyledProps & DisabledProps) =>
    isDisabled &&
    `
    color: ${theme.colors.grey[500]};
  `}
`;

export const StyledViewTitleContainer = styled(View)`
  flex-direction: row;
  margin-bottom: 2px;
`;
